import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partner-agreement',
  templateUrl: './partner-agreement.component.html',
  styleUrls: ['./partner-agreement.component.css']
})
export class PartnerAgreementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  scrollTo(element: any): void {
    (document.getElementById(element) as HTMLElement).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}
